import { Pipe } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";


@Pipe({ name: 'safeHtml' })
export class SafeHTMLPipe {
  constructor(private sanitizer: DomSanitizer) { }

  transform(style) {
    return this.sanitizer.bypassSecurityTrustHtml(style);
  }
}

@Pipe({ name: 'safeResourceUrl' })
export class SafeResourceUrlPipe {
  constructor(private sanitizer: DomSanitizer) { }

  transform(style) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(style);
  }
}

@Pipe({ name: 'safeUrl' })
export class SafeUrlPipe {
  constructor(private sanitizer: DomSanitizer) { }

  transform(style) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(style);
  }
}